import { render } from "./StudentVerification.vue?vue&type=template&id=8429b97a&scoped=true"
import script from "./StudentVerification.vue?vue&type=script&lang=js"
export * from "./StudentVerification.vue?vue&type=script&lang=js"

import "./StudentVerification.vue?vue&type=style&index=0&id=8429b97a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8429b97a"]])

export default __exports__